const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Resolve a media reference to a fully qualified URL.
 *   - If it starts with http(s):// return as-is (legacy external URLs)
 *   - Otherwise treat as a storage path and prefix with /api/files/
 */
export function resolveMedia(value) {
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  return `${BACKEND_URL}/api/files/${value}`;
}
